import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Layout from './Layout';

// Loading spinner component
function LoadingSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Loading...</p>
      </div>
    </div>
  );
}

// ProtectedRoute component with real authentication
export function ProtectedRoute() {
  const { user, isLoading, isInitialized } = useAuth();
  
  // Show loading while auth is being initialized
  if (!isInitialized || isLoading) {
    return <LoadingSpinner />;
  }
  
  // Redirect to login if user is not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  // Render protected content with layout
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

